import {TimePicker, TimePickerProps} from "@mui/x-date-pickers";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";
import {StyledTextField} from "../components/StyledTextField";

type FormTimePickerProps<IFormValues extends FieldValues = FieldValues> = Omit<TimePickerProps<any, any>,
    "renderInput" | "value" | "onChange"> & {
    name: Path<IFormValues>;
    control?: Control<IFormValues, any>;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    handleChange?: Function;
};

const FormTimePicker = <IFormValues extends FieldValues = FieldValues>({
                                                                           name,
                                                                           control,
                                                                           label,
                                                                           readOnly,
                                                                           required,
                                                                           handleChange,
                                                                           ...props
                                                                       }: FormTimePickerProps<any>) => {
    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, fieldState}) => (
                <TimePicker
                    {...props}
                    label="Basic example"
                    value={field.value || ""}
                    onChange={(value) => {
                        if (handleChange) {
                            handleChange(value);
                        } else {
                            field.onChange(value);
                        }
                    }}
                    disabled={readOnly}
                    inputFormat={"LT" || props.inputFormat}
                    renderInput={(params) => (
                        <StyledTextField
                            {...params}
                            required={required}
                            label={label}
                            onBlur={field.onBlur}
                            error={Boolean(fieldState.error)}
                            fullWidth
                            helperText={fieldState.error?.message}
                        />
                    )}
                />
            )}
        />
    );
};

export default FormTimePicker;
